var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BadgeCampaignList",
      "extra-items": _vm.isReadOnly ? [{
        text: _vm.form.name.length > 13 ? _vm.form.name.slice(0, 13) + '...' : _vm.form.name
      }] : _vm.isEdit ? [{
        text: _vm.form.name.length > 13 ? _vm.form.name.slice(0, 13) + '...' : _vm.form.name,
        to: 'BadgeCampaignView',
        params: _vm.$route.params.id
      }, '編輯'] : ['新增']
    }
  })], 1)]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-end"
  }, [_c('div', {
    staticClass: "col-8 d-flex items-center"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "編輯" : _vm.isReadOnly ? "查看" : "新增") + " ")])])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-8"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "徽章活動名稱",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "type": "text",
      "readonly": _vm.isReadOnly,
      "state": _vm.v$.form.name.$error ? false : null
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v("此欄位為必填")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "主圖",
      "label-for": "subtitle"
    }
  }, [_c('div', {
    staticClass: "image-selector"
  }, [_vm.imageFile || _vm.form.image_url ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.imageFile != null ? _vm.imageFile : _vm.form.image_url
    }
  }), !_vm.isReadOnly ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.imageFile = _vm.form.image_url = null;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times m-0"
  })]) : _vm._e()]) : _c('div', {
    staticClass: "selector"
  }, [_c('ImageSelectorWithoutCrop', {
    staticClass: "\n                    border\n                    h-100\n                    d-flex\n                    justify-content-center\n                    align-items-center\n                  ",
    on: {
      "input": _vm.selectImage
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function fn(_ref) {
        var openFileSelector = _ref.openFileSelector;
        return [_c('button', {
          staticClass: "btn s-trigger-btn",
          on: {
            "click": openFileSelector
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        }), _vm._v(" 圖片 ")])];
      }
    }])
  })], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "注意事項",
      "label-for": "memo"
    }
  }, [_c('classic-editor', {
    staticClass: "form-control mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "extra-plugins": [_vm.MyCustomUploadAdapterPlugin],
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.memo,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "memo", $$v);
      },
      expression: "form.memo"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間設定",
      "label-for": "start_at"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabledDates": _vm.disabledDates,
      "disabled": _vm.isReadOnly,
      "state": _vm.v$.start_at.date.$error ? false : null
    },
    model: {
      value: _vm.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.start_at, "date", $$v);
      },
      expression: "start_at.date"
    }
  })], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.isReadOnly,
      "state": _vm.v$.start_at.time.HH.$error || _vm.v$.start_at.time.mm.$error ? false : null
    },
    model: {
      value: _vm.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.start_at, "time", $$v);
      },
      expression: "start_at.time"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.time.HH.$error || !_vm.v$.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "結束時間設定",
      "label-for": "end_at"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabledDates": _vm.disabledDates,
      "disabled": _vm.isReadOnly,
      "state": _vm.v$.end_at.date.$error ? false : null
    },
    model: {
      value: _vm.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.end_at, "date", $$v);
      },
      expression: "end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control'],
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.end_at, "time", $$v);
      },
      expression: "end_at.time"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.end_at.time.HH.$error || !_vm.v$.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "狀態",
      "label-for": "type"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "status",
      "options": _vm.statusOptions,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goToList
    }
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "返回" : "取消") + " ")]), !_vm.isReadOnly ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }